var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicSometimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.739,
    height: 29.99,
    viewBox: "0 0 37.739 29.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_100",
    "data-name": "Gruppe 100",
    transform: "translate(-901.081 -1202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_657",
    "data-name": "Pfad 657",
    d: "M228.2,162.033l-8.5,9.141h-4.317a.784.784,0,0,0-.784.784V181.6a.784.784,0,0,0,.784.784H219.7l8.5,9.14a.784.784,0,0,0,1.357-.534V162.567A.784.784,0,0,0,228.2,162.033Z",
    transform: "translate(686.486 1040.219)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 2.399,
    cy: 2.399,
    r: 2.399,
    transform: "translate(919.627 1214.51)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 2.399,
    cy: 2.399,
    r: 2.399,
    transform: "translate(926.824 1214.51)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 2.399,
    cy: 2.399,
    r: 2.399,
    transform: "translate(934.022 1214.51)",
    fill: "#454545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicSometimes);
export default __webpack_public_path__ + "static/media/music-sometimes.f3460f0354e8e90091a17c765ff9705a.svg";
export { ForwardRef as ReactComponent };